import { useCallback } from "react";
import { useAuth } from "react-oidc-context";
import { useConfig } from "../config/ConfigProvider";

/**
 * Log out of the app and the Cognito session.
 *
 * Cognito's OIDC metadata does not reliably advertise an `end_session_endpoint`,
 * so we remove the local user and then redirect the browser to the Hosted UI
 * `/logout` endpoint, which clears the Cognito session cookie.
 */
export function useLogout(): () => Promise<void> {
  const auth = useAuth();
  const { cognito } = useConfig();

  return useCallback(async () => {
    try {
      await auth.removeUser();
    } finally {
      const url =
        `${cognito.domain}/logout` +
        `?client_id=${encodeURIComponent(cognito.clientId)}` +
        `&logout_uri=${encodeURIComponent(cognito.logoutUri)}`;
      window.location.assign(url);
    }
  }, [auth, cognito.domain, cognito.clientId, cognito.logoutUri]);
}
